// extracted by mini-css-extract-plugin
module.exports = {"app_crash_container":"AppCrash_app_crash_container__2sHSE"};